<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center" >
                    <v-col class="text-left col-md-6">
                        <div class="font-weight-bold body-1">
                            Editar Eventualidad
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <v-form ref="form" @submit.prevent="save">
                            <event-form ref="Eventform" :values="form" @save="save" :serverErrors="serverErrors" :editMode="true"></event-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="6" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Eventform from "./EventForm.vue";
import Utils from "../../../../helpers/Utils";
export default {
    components: {
        'event-form': Eventform,
       
    },
	data(){
		return {
            eventId: this.$route.params.eventId,
            employee_id: this.$route.params.employee,
            loading: false,
            serverErrors: {},
            form: {
                company: '',
                location: '',
                employee_id: '',
                type: '',
                start_date: '',
                end_date: '',
                reason: '',
                amount: '',
                comments: '',

                required_auth: true,    //??????
                allowed: true,          //??????
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                // to: "",	
                block:false,
                click: this.toEvents
            },
            saveBtnData: {
                text: "Guardar cambios",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
		validate () {
			return this.$refs.form.validate()
		},
        toEvents(){
            this.$router.push(`/colaboradores/${this.employee_id}/estadisticas`);
        },
        index(){
            this.loading = true;
            this.$store.state.loading = true;
			this.$api.eventuality.get(this.eventId)
			.then((response) => {
                this.form = response.data;
                this.form = {...this.form, employee_id: response.data.employee.id};
                console.log(this.form);
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
        },
        save(){
            this.saveBtnData.loading = true;
            this.$store.state.loading = true;
           
           
            //console.log(this.form);
            if(this.validate()){
                
                const request = this.prepareRequest(this.form);
                
                this.$api.eventuality.update(this.eventId, request)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.toEvents();
                    })
                    .catch((error) => {
                        //console.log(error.response)
                        var errors = []
                        switch(error.response.status){
                            case 400: 
                                //console.log(99, error.response);
                                if(("message" in error.response.data)){
                                    Object.keys(error.response.data.message).forEach((x) => {
                                        //console.log(x);
                                        this.serverErrors = error.response.data.message;
                                        error.response.data.message[x].forEach((y) => {
                                            this.serverErrors[x] = Utils.deleteWord(x,y);
                                            errors.push(Utils.deleteWord(x,y))
                                        })
                                    });
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }

                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                this.saveBtnData.loading = false;
                this.$store.state.loading = false;
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },

        /**
         * Process data
         */
        prepareRequest(data){
            let newData = JSON.parse(JSON.stringify(data));

            newData.amount = parseFloat(parseFloat(newData.amount).toFixed(2));
            return newData;
        }
    },
}
</script>

<style>

</style>